import styled, { css } from 'styled-components';

export const Container = styled.div<{ $width: string }>(
  ({ $width }) => css`
    width: ${$width};
    overflow: hidden;
  `,
);

export const Header = styled.header`
  display: flex;
  padding: 15px;
  border-bottom: 5px solid ${({ theme }) => theme.black.a1};
  justify-content: space-between;
  font-weight: 600;
  line-height: 1.67;
  align-items: center;
`;

export const SelectedCount = styled.div`
  color: ${({ theme }) => theme.baseBlue.a10};
  font-size: 1rem;
  letter-spacing: 0.5px;
`;

export const ClearBtn = styled.button`
  text-transform: uppercase;
  color: ${({ theme }) => theme.baseBlue.a6};
  font-size: 0.8rem;
  letter-spacing: 1.25px;
  font-weight: 600;
  line-height: 1.67;
`;

export const SaveContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 15px;
  border-top: 1px solid ${({ theme }) => theme.black.a1};
`;
